module.exports = __webpack_public_path__ + "static/media/mycenaean_text_05.89ba598a.jpg";